const emptyManualAddressValues = {
  houseNameNumber: '',
  streetName: '',
  line2: '',
  city: '',
  state: '',
  postcode: '',
  buildingName: '',
  buildingNumber: '',
  street: '',
};

export { emptyManualAddressValues };
